import React from 'react';
import { ColumnLayout, FormField, Input, Multiselect, Select, SpaceBetween } from '@cloudscape-design/components';
const uses = [{ value: 'group', label: 'Calculated group' }, { value: 'funding', label: 'Participant funding' }, { value: 'expense', label: 'Other expenditure' }];
const sources = [{ value: '', label: 'Not specified' }, { value: 'EI', label: 'EI' }, { value: 'CRF', label: 'CRF' }, { value: 'OTHER', label: 'Other' }];

export default function BudgetPlanningPotFields({ value, onChange, original, hasChildren, regionOptions }) {
  const update = patch => onChange({ ...value, ...patch });
  const regions = (value.regions || []).map(code => regionOptions.find(option => option.value === code) || { value: code, label: code });
  const group = value.use === 'group';
  return <SpaceBetween size="m">
    <ColumnLayout columns={2} minColumnWidth={260}>
      <FormField label="Budget code">
        <Input ariaLabel="Budget code" value={value.code || ''} readOnly={!!original} onChange={({ detail }) => update({ code: detail.value, codeEdited: true })} />
      </FormField>
      <FormField label="Use for"><Select ariaLabel="Use for" selectedOption={uses.find(option => option.value === value.use) || null} options={uses}
        disabled={!!original || hasChildren} placeholder="Choose use" onChange={({ detail }) => update({ use: detail.selectedOption.value,
          ...(detail.selectedOption.value === 'group' ? { regions: [], fundingSource: '' } : {}) })} /></FormField>
    </ColumnLayout>
    {(!group || original) && <ColumnLayout columns={2} minColumnWidth={260}>
      <FormField label={value.use === 'funding' ? 'Funding source' : 'Funding source (optional)'}><Select ariaLabel="Funding source"
        selectedOption={sources.find(option => option.value === value.fundingSource) || sources[0]} options={sources}
        disabled={!!original} onChange={({ detail }) => update({ fundingSource: detail.selectedOption.value })} /></FormField>
      <FormField label="Regions">
        <Multiselect ariaLabel="Regions" options={regionOptions} selectedOptions={regions} disabled={!!original} filteringType="auto" expandToViewport
          placeholder="Choose regions" onChange={({ detail }) => update({ regions: detail.selectedOptions.map(option => option.value), regionsEdited: true })} />
      </FormField>
    </ColumnLayout>}
    <ColumnLayout columns={2} minColumnWidth={260}>
      <FormField label="External GL/project code"><Input ariaLabel="External GL/project code" value={value.glProjectCodeExternal || ''}
          onChange={({ detail }) => update({ glProjectCodeExternal: detail.value })} /></FormField>
      <FormField label="Internal GL/project code"><Input ariaLabel="Internal GL/project code" value={value.glProjectCodeInternal || ''}
          onChange={({ detail }) => update({ glProjectCodeInternal: detail.value })} /></FormField>
    </ColumnLayout>
  </SpaceBetween>;
}
